import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { SystemStateMessageTypes } from '../../../models/SystemStateMessageTypes';

const putInfo = (params: { message: string }) => async (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.putMessage({ type: SystemStateMessageTypes.INFO, message: params.message }));
};
const putError = (params: { message: string }) => async (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.putMessage({ type: SystemStateMessageTypes.ERRROR, message: params.message }));
};
const putSuccess = (params: { message: string }) => async (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.putMessage({ type: SystemStateMessageTypes.SUCCESS, message: params.message }));
};

const reset = () => async (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.reset());
};

export {
  putInfo,
  putError,
  putSuccess,
  reset
};



// WEBPACK FOOTER //
// ./src/redux/modules/systemStateMessage/operations.ts